/**
 * LockedBadge — small "🔒 PRO" pill for buttons or menu items whose
 * underlying feature isn't currently entitled. Renders nothing when
 * the user HAS the feature.
 *
 * Use:
 *   <Button>
 *     PDF Report
 *     <LockedBadge featureKey="pdf_reports" />
 *   </Button>
 */
import { Lock } from "lucide-react";
import { useEntitlements } from "../hooks/useEntitlements";

export function LockedBadge({ featureKey, className = "" }) {
  const { has, isLoading } = useEntitlements();
  if (isLoading || has(featureKey)) return null;
  return (
    <span
      data-testid={`locked-badge-${featureKey}`}
      title="Función PRO"
      className={
        "inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full " +
        "text-[9px] uppercase font-bold tracking-wider " +
        "bg-amber-100 text-amber-800 border border-amber-200 " +
        className
      }
    >
      <Lock className="h-2.5 w-2.5" />
      PRO
    </span>
  );
}
